import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ScanResult from './pages/ScanResult';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/scan" element={<ScanResult />} />
            </Routes>
        </Router>
    );
}

export default App;
